import React, { useCallback, useEffect, useRef, useState } from "react";
import { Index } from "elasticlunr";
import _debounce from "lodash/debounce";

import { SearchContainer, SearchInput, SearchLi, SearchUl } from "./styles";
import { Link } from "gatsby-link";
import Icon from "../Icon";

const Search = ({ searchIndex, onBlurInput }) => {
  const [query, setQuery] = useState(``);
  const [results, setResults] = useState([]);
  const indexRef = useRef();
  const inputRef = useRef();

  const getOrCreateIndex = () =>
    indexRef.current ? indexRef.current : Index.load(searchIndex);

  const getOptions = (query) => {
    setResults(
      indexRef.current
        .search(query, { expand: true })
        .map(({ ref }) => indexRef.current.documentStore.getDoc(ref))
    );
  };

  // eslint-disable-next-line react-hooks/exhaustive-deps
  const debouncedGetOptions = useCallback(_debounce(getOptions, 300), []);

  const search = (evt) => {
    const query = evt.target.value;
    indexRef.current = getOrCreateIndex();
    setQuery(query);
    debouncedGetOptions(query);
  };

  useEffect(() => {
    inputRef.current?.focus();
  }, []);

  return (
    <SearchContainer>
      <SearchInput
        type="text"
        value={query}
        onChange={search}
        ref={inputRef}
        onBlur={onBlurInput}
      />
      <SearchUl>
        {results.map((page) => {
          return (
            <SearchLi key={page.id}>
              <Icon type={"Search"} />
              <Link to={`/case-studies/${page.slug}`}>{page.title}</Link>
            </SearchLi>
          );
        })}
      </SearchUl>
    </SearchContainer>
  );
};

export default Search;
